export const StatusLabels = {
    active: 'Active',
    inactive: 'Inactive',
} as const;
